<template>
  <v-app>
    <AppBar
      v-if="userUtils.isSignedIn() && !userUtils.inMaintenanceMode()"
    ></AppBar>
    <v-main>
      <router-view></router-view>
    </v-main>
  </v-app>
</template>

<script>
import userUtils from "@/utils/userUtils";

export default {
  name: 'App',

  components: {
    AppBar: () => import("@/components/AppBar"),
  },

  data: () => ({
    userUtils: userUtils
  }),

  /*created() {
    this.signedIn = userUtils.isSignedIn();
  },*/

};
</script>
